var map = {
	"./albergolosone.jpg": 788,
	"./ameronswissmountain.jpg": 4093,
	"./artdecomontana.jpg": 6970,
	"./arthotel-riposo.jpg": 5840,
	"./ascovilla.jpg": 6167,
	"./atlantis.jpg": 1762,
	"./backstage-vernissage.jpg": 8455,
	"./badrutt-s-palace.jpg": 35,
	"./baur-au-lac.jpg": 4138,
	"./beatus.jpg": 2151,
	"./beaurivage.jpg": 1207,
	"./beaurivagepalace.jpg": 1842,
	"./bergwelt-grindelwald.jpg": 9536,
	"./bodmi.jpg": 5408,
	"./buergenstock.jpg": 5817,
	"./castello_del_sole.jpg": 5802,
	"./chedi.jpg": 6591,
	"./chesa-randolina.jpg": 1693,
	"./de_rougemont.jpg": 7629,
	"./deltapark.jpg": 9452,
	"./doldenhorn.jpg": 9189,
	"./dolder-grand.jpg": 8199,
	"./eden-roc.jpg": 4863,
	"./ermitage.jpg": 5820,
	"./fairmontlemontreux.jpg": 988,
	"./fourseasons.jpg": 5975,
	"./fruttfamilylodge.jpg": 2704,
	"./giardino.jpg": 4121,
	"./ginabelle.jpg": 6364,
	"./golfpanorama.jpg": 7808,
	"./grandhotelquellenhof.jpg": 4254,
	"./gstaad-palace.jpg": 6975,
	"./hof_weissbad.jpg": 4695,
	"./huus-gstaad.jpg": 7303,
	"./kempinski.jpg": 5375,
	"./kulm.jpg": 4626,
	"./la-reserve-geneve.jpg": 5822,
	"./le-grand-bellevue.jpg": 4587,
	"./lenkerhof.jpg": 160,
	"./lestroisrois.jpg": 9491,
	"./maerchenhotelbraunwald.jpg": 8411,
	"./mandarin-oriental.jpg": 1543,
	"./mirador.jpg": 7840,
	"./nira-alpina.jpg": 3693,
	"./parkhotel-delta.jpg": 946,
	"./parkhotel-margna.jpg": 4348,
	"./pirmin-zurbriggen.jpg": 1012,
	"./placeholder.jpg": 5334,
	"./priva.jpg": 3530,
	"./radissonblue.jpg": 8115,
	"./rocksresort.jpg": 8264,
	"./romantik-hotel-julen-zermatt.jpg": 3363,
	"./saratz.jpg": 7823,
	"./schweizerhof.jpg": 8844,
	"./schweizerhofbern.jpg": 8250,
	"./spitzhorn.jpg": 7492,
	"./sunstar-arosa.jpg": 2786,
	"./suvretta-house.jpg": 9989,
	"./swiss_holiday_park.jpg": 1499,
	"./the-alpina.jpg": 7762,
	"./thehide.jpg": 7899,
	"./tschuggen.jpg": 978,
	"./ultima-gstaad.jpg": 9533,
	"./valbella-resort.jpg": 9836,
	"./valbellainn.jpg": 4608,
	"./valsana.jpg": 1897,
	"./victoriajungfrau.jpg": 4887,
	"./vitznauerhof.jpg": 5877,
	"./widder.jpg": 933
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 1 | 16);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 1450).then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 2529;
module.exports = webpackAsyncContext;